/**
 * Clean the Peer by closing the RTCPeerConnection.
 * @method close
 */
export default function close () {
  const { nativePeer, id, emitter, iceLoop, log } = this
  log.info('Closing Peer.')

  if (iceLoop) {
    // Clear the ICE collection loop timeout if it exists.
    clearTimeout(iceLoop)
  }

  nativePeer.close()
  emitter.emit('peer:closed', id)
}
